import React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import DashboardPage from '../../Pages/Home/Home';
import { UserProfileDashboard } from '../../Pages/UserProfileDashboard';
import { withResponsiveContainer } from '../Layout/ResponsiveContainer';
import { NewMemberForm } from '../Questionnaire/NewMemberForm';
import Questionnaire from '../Questionnaire/Questionnaire';
import AdminConsole from '../../Pages/Admin/AdminConsole';
import { useAgeReadyContext } from '../../AgeReadyContext/AgeReadyContext';
import ResourcesPage from '../../Pages/ResourcesPage';

export const Routes: React.FC = () => {
  const { caregiverStore } = useAgeReadyContext();

  const getRedirectPath = () => {
    if (caregiverStore.recipients.length === 0) {
      return 'onboarding';
    }
    return 'home';
  };
  return (
    <>
      <BrowserRouter>
        <Switch>
          <Redirect from='/' exact to={getRedirectPath()} />
          <Route
            path='/user-profile'
            component={withResponsiveContainer(
              UserProfileDashboard,
              'User Profile'
            )}
          />
          <Route
            path='/home'
            component={withResponsiveContainer(DashboardPage, 'Home')}
          />
          <Route
            path='/add-recipient'
            component={withResponsiveContainer(Questionnaire, 'Questionnaire')}
          />
          <Route
            path='/onboarding'
            component={withResponsiveContainer(NewMemberForm, 'NewMemberForm')}
          />
          <Route
            path='/admin/:partnerId'
            component={withResponsiveContainer(AdminConsole, 'Admin')}
          />
          <Route
            path='/resource-page'
            component={withResponsiveContainer(ResourcesPage, 'Resource')}
          />
        </Switch>
      </BrowserRouter>
    </>
  );
};
